import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import MissionSection from './components/MissionSection';
import ChallengesSection from './components/ChallengesSection';
import ProgramsSection from './components/ProgramsSection';
import ImpactSection from './components/ImpactSection';
import BeneficiariesSection from './components/BeneficiariesSection';
import WhyIkiruSection from './components/WhyIkiruSection';
import CtaSection from './components/CtaSection';

export default function HomePage() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <MissionSection />
      <ChallengesSection />
      <ProgramsSection />
      <ImpactSection />
      <BeneficiariesSection />
      <WhyIkiruSection />
      <CtaSection />
      <Footer />
    </main>
  );
}
